/**
 * Single app-level host for the global alert modal. Mounted once (next to <Snackbar/>) so any
 * code can raise a blocking alert via `dispatch(showAlertDialog(...))` or the `useAlert` hook,
 * replacing imperative `window.alert()` calls with a GGC-styled, i18n-aware dialog.
 */
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { closeAlertDialog } from '@/store/slices/alertDialogSlice';
import { AlertDialog } from '@/components/AlertDialog';

export default function GlobalAlertDialog() {
  const dispatch = useAppDispatch();
  const { open, message, title, tone, confirmLabel } = useAppSelector((s) => s.alertDialog);
  return (
    <AlertDialog
      open={open}
      message={message}
      title={title}
      tone={tone}
      confirmLabel={confirmLabel}
      onClose={() => dispatch(closeAlertDialog())}
    />
  );
}
